export class CuttingPanelOptions {
  recalculatedToFinishedSize = false;
}
